module.exports = __webpack_public_path__ + "img/form-banner-desktop.5bcca365.png";